export const paneStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  flex: 1,
  minWidth: 0,
};

export const headerRowStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
  paddingBottom: 1.5,
  borderBottom: `1px solid ${palette.divider}`,
});

export const headerDurationStyles = ({ palette }) => ({
  marginLeft: 'auto',
  color: palette.text.secondary,
  fontVariantNumeric: 'tabular-nums',
});

export const detailsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export const tabsRowStyles = ({ palette }) => ({
  display: 'inline-flex',
  gap: 0.5,
  padding: 0.5,
  borderRadius: 2,
  backgroundColor: palette.background.default,
  width: 'fit-content',
});

export const getTabStyles =
  isActive =>
  ({ palette, transition }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingX: 1.5,
    paddingY: 0.75,
    borderRadius: 1.5,
    cursor: 'pointer',
    transition: transition?.default,
    backgroundColor: isActive ? palette.background.paper : 'transparent',
    color: isActive ? palette.text.primary : palette.text.secondary,
    boxShadow: isActive ? palette.shadow?.s : 'none',

    '&:hover': {
      color: palette.text.primary,
    },
  });
